// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"5ebc238c","787":"1ee28b83"}[chunkId] + ".chunk.js";
};